var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-hint"},[_c('img',{staticClass:"search-hint-icon",attrs:{"src":require("./search-icon.png")}}),_c('span',{staticClass:"search-hint-text"},[_vm._v(_vm._s(_vm.$t("pages.dream_home.search_results.empty_state_cue")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }